export default __webpack_public_path__ + "static/format-eksempel2-78c0482cfe7d4313fcc46bb8d00ad971.png";